// extracted by mini-css-extract-plugin
export var assigneeBadge = "_l9-0";
export var assigneeDetails = "_l9-1";
export var assigneeInfo = "_l9-2";
export var dropdownContainer = "_l9-4";
export var dropdownImage = "_l9-5";
export var editAssigneeInfo = "_l9-3";
export var editAssigneeModalContainer = "_l9-6";
export var hidden = "_l9-8";
export var input = "_l9-7";